import type {
    AddressState,
    AboutYouState,
    ApplicantState,
    FinancialDetailsState,
    HomeLoanEnquiryState,
    GeneralEnquiryState,
} from './types';

export const addressInitialState: AddressState = {
    dpid: '',
    address: '',
    unitNumber: '',
    streetName: '',
    streetNumber: '',
    streetType: '',
    suburb: '',
    state: '',
    postcode: '',
};

export const aboutYouInitialState: AboutYouState = {
    firstName: '',
    middleName: '',
    lastName: '',
    emailAddress: '',
    mobileNumber: '',
    ageRange: '',
    contactMethod: '',
    contactMethodGeneral: '',
    isExistingCustomer: null,

    //Employment details
    employmentStatus: '',
    grossSalary: 0,

    //Address details
    residentialAddress: addressInitialState,
    customerId: null
};

export const financialDetailsInitialState: FinancialDetailsState = {
    homeLoanBorrowingAmount: 0,
    homeLoanAdditionalFunds: 0,

    personalLoanBorrowingAmount: 0,
    personalLoanBorrowingPurpose: '',
    personalLoanHousingSituation: '',
    personalLoanHasExistingHomeLoan: null,
};

export const homeLoanEnquiryInitialState: HomeLoanEnquiryState = {
    IsApplyingOnline: null,
    IsLenderEnquiry: null,
    IsExistingMember: null,
    IsOwnerOccupied: false,
    ApplicationType: '',
    PropertyLoanType: '',
    EnquiryType: '',
    EnquiryFormConfiguration: null,
    OnlineEligibility: false,
    CampaignCode: '',
};

export const generalEnquiryInitialState: GeneralEnquiryState = {
    generalMessage: '',
};


export const applicantInitialState: ApplicantState = {
    applicantId: '',
    customerId: '',
    homeLoanEnquiryDetails: homeLoanEnquiryInitialState,
    aboutYou: aboutYouInitialState,
    financialDetails: financialDetailsInitialState,
    generalEnquiryDetails: generalEnquiryInitialState,

};
